module.exports = __webpack_public_path__ + "img/cisco.0238300b.png";